import React from "react";
import { Plan } from "../../../@types";
import { CollapsibleBox } from "../../../components";
import { useTranslate, isMedicareAdvantageType } from "../../../helpers";
import {
  shouldSuppressPlanBenefits,
  shouldSuppressDrugPricing,
} from "../../../helpers/planHelpers";
import { $$ } from "../../../helpers/currencyUtilities";
import { AppContext } from "../../../app/store";
import { PreviewContext } from "../../../helpers";
import { SubSectionTable } from "./helper";
import { Ga4Event } from "../../../helpers/analytics";

const EstimatedYearlyCostsMATable: React.FunctionComponent<{
  plan: Plan;
}> = ({ plan }) => {
  const t = useTranslate();
  const { state } = React.useContext(AppContext);
  const previewMode = React.useContext(PreviewContext);
  const suppressed = shouldSuppressPlanBenefits(plan);
  const suppressAnnualDrugEstimate =
    state.prescriptions.length && shouldSuppressDrugPricing(plan);
  const {
    oopc: { HEALTH_GOOD: oopc },
  } = plan;

  const checkSuppressed = (value: unknown) => {
    return suppressed ? t("suppressed_plan_benefit") : value;
  };

  const headerTitle = t("plan_details.overview.estimated_yearly_costs");

  // porting the logic from "old" overview code
  const getMedicareAdvantageData = () => {
    const label = t(
      "plan_details.overview.estimated_yearly_costs.estimated_total_yearly_costs"
    );
    return [
      {
        label: (
          <div className="ds-u-font-weight--bold">
            <CollapsibleBox
              labelId="plan_details.overview.estimated_yearly_costs.estimated_total_yearly_costs"
              tealiumProps={{
                event_action: "Plan Details Help Caret",
                event_label: `${headerTitle}|${label}`,
              }}
              ga4Props={{
                event_name: Ga4Event.PLAN_DETAILS_HELP_CARET_CLICKED,
                header: label,
              }}
              open={previewMode}
            >
              <span className="ds-u-font-weight--normal">
                {t(
                  "plan_details.overview.estimated_yearly_costs.estimated_total_yearly_costs.definition"
                )}
              </span>
            </CollapsibleBox>
          </div>
        ),
        value: checkSuppressed(
          suppressAnnualDrugEstimate ? t("na") : $$(oopc.annual_breakdown_total)
        ),
      },
    ];
  };

  return (
    <SubSectionTable data={getMedicareAdvantageData()} caption={headerTitle} />
  );
};

export const EstimatedYearlyCosts: React.FunctionComponent<{
  plan: Plan;
}> = ({ plan }) => {
  // do not display Estimated Yearly Costs for PDP plans or if plan year is > 2021
  if (
    !isMedicareAdvantageType(plan.plan_type) ||
    plan.contract_year !== "2021"
  ) {
    return null;
  }

  return (
    <div>
      <EstimatedYearlyCostsMATable plan={plan} />
    </div>
  );
};
